import React, { Fragment, useState, useEffect } from "react";
import "./Footer.css";
import contactban from "../../images/contact-banner.png";
import enquirygif from "../../images/mogli-chat.gif";
import faqgif from "../../images/FAQs.gif";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearAuthError, submitContactForm } from "../../actions/userActions";
import Loader from "./Loader";
import { TextField } from "@mui/material";
import { toast } from "react-toastify";
import MetaData from "./MetaData";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import { LocationOnOutlined } from "@mui/icons-material";

export default function Support() {
  const { loading, isFormSubmitted, error } = useSelector(
    (state) => state.userState,
  );
  const dispatch = useDispatch();

  const [phone, setPhone] = useState("+91");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pincode, setPincode] = useState("");
  const [requirements, setRequirements] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [yourfunction, setYourFunction] = useState("");
  const [postalAddress, setPostalAddress] = useState("");
  const [country, setCountry] = useState("");
  const [locality, setLocality] = useState("");
  const [city, setCity] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedFormData = {
      name,
      organization: organizationName,
      function: yourfunction,
      mobile: phone,
      email,
      pincode,
      requirements,
      postalAddress,
      country,
      locality,
      city,
    };

    dispatch(submitContactForm(updatedFormData));
  };

  useEffect(() => {
    if (isFormSubmitted) {
      setName("");
      setOrganizationName("");
      setYourFunction("");
      setPhone("+91");
      setEmail("");
      setPincode("");
      setRequirements("");
      setPostalAddress("");
      setCountry("");
      setLocality("");
      setCity("");
      dispatch(clearAuthError());
    }

    if (error) {
      toast(error, { type: "error" });
      dispatch(clearAuthError());
    }
  }, [isFormSubmitted, error, dispatch]);

  const isValidPostalCode = (postalCode) => /^\d{6}$/.test(postalCode);

  const fetchPostalCodeDetails = async (postalCode) => {
    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${postalCode}`,
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching pin code details:", error);
      return null;
    }
  };

  useEffect(() => {
    const loadAddressFromPin = async () => {
      if (!isValidPostalCode(pincode)) return;

      const data = await fetchPostalCodeDetails(pincode);
      if (
        Array.isArray(data) &&
        data[0]?.Status === "Success" &&
        data[0]?.PostOffice?.length > 0
      ) {
        const office = data[0].PostOffice[0];
        setLocality(office.Name || "");
        // setCity(office.District || "");
        setCountry(office.Country || "India");
      } else {
        setLocality("");
        // setCity("");
        setCountry("");
      }
    };

    loadAddressFromPin();
  }, [pincode]);

  return (
    <>
      <MetaData title="Contact Us | GLOCRE Private Limited" />
      <body className="body-contact-glc pt-0">
        <section className="contact-banner-glc">
          <img
            src={contactban}
            className="img-fluid w-100"
            alt="Contact Banner"
          />
        </section>

        {loading ? (
          <Loader />
        ) : (
          <section className="container mb-5">
            <div className="contact-heading-glc">
              <h2>
                Please fill your request, our team will review and get back to
                you shortly
              </h2>
            </div>

            <Fragment>
              <form onSubmit={handleSubmit}>
                <section className="mb-5 col-lg-12">
                  <div className="row d-flex">
                    <div className="cartWrapper mt-1">
                      <div className="Form Contents">
                        <div className="row">
                          {/* Name */}
                          <div className="col-md-6 mb-4">
                            <TextField
                              label="Name"
                              variant="outlined"
                              className="w-100"
                              size="small"
                              required
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              inputProps={{ maxLength: 25 }}
                              onKeyDown={(e) => {
                                const key = e.key;
                                const isLetter = /^[a-zA-Z]$/.test(key);
                                const isAllowedKey = [
                                  "Backspace",
                                  "Tab",
                                  "ArrowLeft",
                                  "ArrowRight",
                                  "Delete",
                                  " ",
                                ].includes(key);
                                if (!isLetter && !isAllowedKey)
                                  e.preventDefault();
                                if (
                                  key === " " &&
                                  e.target.selectionStart === 0
                                )
                                  e.preventDefault();
                              }}
                            />
                          </div>

                          {/* Organization */}
                          <div className="col-md-6 mb-4">
                            <TextField
                              label="Organization Name"
                              variant="outlined"
                              className="w-100"
                              size="small"
                              value={organizationName}
                              onChange={(e) =>
                                setOrganizationName(
                                  e.target.value.replace(/^\s+/, ""),
                                )
                              }
                              inputProps={{ maxLength: 40 }}
                            />
                          </div>

                          {/* Function */}
                          <div className="col-md-6 mb-4">
                            <TextField
                              label="Your Function"
                              variant="outlined"
                              className="w-100"
                              size="small"
                              value={yourfunction}
                              onChange={(e) =>
                                setYourFunction(
                                  e.target.value.replace(/^\s+/, ""),
                                )
                              }
                              inputProps={{ maxLength: 40 }}
                            />
                          </div>

                          {/* Phone */}
                          <div className="col-md-6 mb-4">
                            <TextField
                              label="Phone Number"
                              variant="outlined"
                              className="w-100"
                              size="small"
                              required
                              value={phone}
                              inputProps={{ maxLength: 13 }}
                              onChange={(e) => {
                                let value = e.target.value;
                                if (!value.startsWith("+91"))
                                  value = "+91" + value.replace(/\D/g, "");
                                const digitsOnly = value
                                  .replace("+91", "")
                                  .replace(/\D/g, "");
                                value = "+91" + digitsOnly.substring(0, 10);
                                setPhone(value);
                              }}
                              onKeyDown={(e) => {
                                if (e.key === " ") e.preventDefault();
                                if (
                                  (e.target.selectionStart <= 3 &&
                                    ["Backspace", "Delete"].includes(e.key)) ||
                                  (e.ctrlKey && ["x", "X"].includes(e.key))
                                ) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>

                          {/* Email */}
                          <div className="col-md-6 mb-4">
                            <TextField
                              label="E-Mail Address"
                              variant="outlined"
                              className="w-100"
                              size="small"
                              type="email"
                              required
                              value={email}
                              onChange={(e) =>
                                setEmail(e.target.value.replace(/\s/g, ""))
                              }
                              onKeyDown={(e) => {
                                if (e.key === " ") e.preventDefault();
                              }}
                              inputProps={{
                                pattern: "^[^\\s]+$",
                                title: "Spaces are not allowed",
                              }}
                            />
                          </div>

                          {/* PIN Code */}
                          <div className="col-md-6 mb-4">
                            <TextField
                              label="PIN Code"
                              variant="outlined"
                              className="w-100"
                              size="small"
                              required
                              value={pincode}
                              inputProps={{ maxLength: 6 }}
                              onChange={(e) =>
                                setPincode(
                                  e.target.value.replace(/\D/g, "").slice(0, 6),
                                )
                              }
                            />
                          </div>

                          {/* Auto-filled Locality */}
                          <div className="col-md-6 mb-4">
                            <TextField
                              label="Locality"
                              variant="outlined"
                              className="w-100"
                              size="small"
                              value={locality}
                              InputProps={{ readOnly: true }}
                            />
                          </div>

                          {/* Auto-filled City */}
                          <div className="col-md-6 mb-4">
                            <TextField
                              label="City"
                              variant="outlined"
                              className="w-100"
                              size="small"
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                              inputProps={{ maxLength: 40 }}
                            />
                          </div>

                          {/* Auto-filled Country */}
                          <div className="col-md-6 mb-4">
                            <TextField
                              label="Country"
                              variant="outlined"
                              className="w-100"
                              size="small"
                              value={country}
                              InputProps={{ readOnly: true }}
                            />
                          </div>

                          {/* Postal Address */}
                          <div className="col-md-6 mb-4">
                            <TextField
                              label="Postal Address"
                              variant="outlined"
                              className="w-100"
                              size="small"
                              value={postalAddress}
                              onChange={(e) => setPostalAddress(e.target.value)}
                              inputProps={{ maxLength: 200 }}
                            />
                          </div>

                          {/* Requirements */}
                          <div className="col-md-12 mb-4">
                            <TextField
                              label="Requirements"
                              variant="outlined"
                              className="w-100"
                              size="small"
                              required
                              placeholder="Your Requirements (Feedback / Suggestions / New Product Enquiry)"
                              value={requirements}
                              inputProps={{ maxLength: 300 }}
                              onChange={(e) => setRequirements(e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Submit */}
                        <div className="d-flex justify-content-center mt-4">
                          <button
                            className="btn"
                            type="submit"
                            style={{
                              backgroundColor: "#2f4d2a",
                              color: "#fff",
                            }}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </form>
            </Fragment>
          </section>
        )}

        {/* Enquiry Section */}
        <section
          className="contact-details-glc mb-5"
          style={{ backgroundColor: "#f5f5f5" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-4">
                  <h3 style={{ color: "#2f4d2a", textTransform: "uppercase", fontSize: "23px" }}>FAQ's</h3>
                </div>
                <Link to="/faqs">
                  <div className="card">
                    <div className="card-body">
                      <div className="row" style={{ padding: "2% 0" }}>
                        <div className="col-lg-4">
                          <img src={faqgif} className="img-fluid w-100" />
                        </div>
                        <div className="col-lg-8 d-flex flex-column justify-content-center">
                          <h6
                            className="card-subtitle mb-2"
                            style={{ fontSize: "18px", color: "#e53840" }}
                          >
                            FAQ's
                          </h6>
                          <p className="card-text" style={{ fontSize: "16px" }}>
                            Find quick answers to common questions about our
                            products, shipping, returns, and more. If you can't
                            find what you're looking for, feel free to contact
                            our support team.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col-lg-6">
                <div className="mb-4">
                  <h3 style={{ color: "#2f4d2a", textTransform: "uppercase", fontSize: "23px" }}>
                    Registered Office Address
                  </h3>
                </div>
                <div className="card" style={{ height: "240px" }}>
                  <div
                    className="card-body d-flex align-items-center px-4"
                    style={{ height: "100%" }}
                  >
                    <div
                      style={{
                        width: "25%",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <LocationOnOutlined
                        style={{
                          color: "#ffad63",
                          fontSize: "90px",
                        }}
                      />
                    </div>

                    <div style={{ width: "75%" }}>
                      <h5
                        style={{
                          color: "#e53840",
                          fontWeight: "600",
                          marginBottom: "12px",
                        }}
                      >
                        Glocre Private Limited
                      </h5>

                      <p
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          lineHeight: "1.8",
                          color: "#555",
                        }}
                      >
                        225, S.F 607/2B/2, Palamalai Road,
                        <br />
                        SRKV Post, Periyanaickenpalayam,
                        <br />
                        Coimbatore, Tamil Nadu - 641020, India.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="col-lg-6">
                <div className="mb-4">
                  <h3 style={{ color: "#2f4d2a", textTransform: "uppercase" }}>
                    Registered Office Address
                  </h3>
                </div>
                <div className="card" style={{ height: "240px" }}>
                  <div className="card-body">
                    <div className="row" style={{ padding: "2% 15px" }}>
                      <div className="mb-3">
                        <LocationOnOutlined
                          style={{ color: "#ffad63", fontSize: "40px" }}
                        />
                      </div>
                      <div>
                        <p className="mt-2" style={{ fontSize: "16px" }}>
                            <strong style={{ fontSize: '18px', color: '#e53840' }}>
                          Glocre Private Limited
                        </strong><br />
                          225, S.F 607/2B/2, Palamalai road,<br />
                          SRKV Post, Periyanaickenpalayam,<br />
                          Coimbatore, Tamil Nadu - 641020, India.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </section>
      </body>
    </>
  );
}
